<template>
    <el-dialog title="复制实例" width="80%"
        :visible="visible"
        :close-on-click-modal="false"
        @close="cancel"
    >
        <!-- <div v-if="serviceMode">
            <h3>输入新设备</h3>
            <el-table :data="newDevices">
                <el-table-column label="IP" align="center">
                    <template v-slot="{row}">
                        <el-input v-model="row.ip" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称" align="center">
                    <template v-slot="{row}">
                        <el-input v-model="row.name" size="mini"></el-input>
                    </template>
                </el-table-column>

                <el-table-column label="设备所在地" align="center">
                    <template v-slot="{row}">
                        <el-input v-model="row.area" size="mini"></el-input>
                    </template>
                </el-table-column>

                <el-table-column label="所属机房" align="center">
                    <template v-slot="{row}">
                        <el-input v-model="row.room" size="mini"></el-input>
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center">
                    <template v-slot="{$index}">
                        <el-button type="primary" size="mini" @click="addNewDevice">新增</el-button>
                        <el-button type="danger" size="mini"
                            v-if="newDevices.length > 1"
                            @click.native.prevent="delNewDevice($index)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div> -->
        <div>
            <h3>勾选已有设备</h3>
            <device-all ref="device"
                :serviceMode="serviceMode"
                :copyFailed.sync="copyFailed"
                :copies="copies"
                :deviceId="deviceId"
                :containerType="containerType"/>
        </div>
        <div style="margin-top:20px;text-align:center;">
            <el-button type="primary" @click="save">确定</el-button>
            <el-button @click="cancel">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { Loading } from "element-ui";
import DeviceAll from './DeviceAll'
export default {
    components: { DeviceAll },
    props: {
        visible:{
            type: Boolean,
        },
        instanceId:{
            type: [String, Number]
        },
        // 非服务模式不显示新增设备
        serviceMode: {
            type: Boolean,
        },
        containerType: {
            type: String
        },
        // 已经成功复制过的实例
        copies: {
            type: Array,
            default: ()=>{
                return []
            }
        },
        // 当前实例所在的设备
        deviceId: {
            type: [String, Number]
        }
    },
    data: vm=>({
        newDevices: [{
            ip:'',
            name: '',
            room: '',
            area: ''
        }], //新增设备
        selectDevices: [], //勾选的设备
        copyFailed: [], //复制失败的设备
    }),
    methods: {
        save(){
            let model = {
                instanceId: this.instanceId,
                oldDevices: [],
                newDevices: this.newDevices.filter(newDevice => newDevice.ip)
            }
            let oldDevices = this.$refs.device.selects
            this.$refs.device.setOldSelects()
            if(oldDevices && oldDevices.length > 0) {
                oldDevices.forEach(odevice => {
                    model.oldDevices.push({
                        deviceId: odevice.deviceId,
                        containerId: odevice.containerId
                    })
                })
            }

            if(model.oldDevices.length == 0 && model.newDevices.length == 0) {
                this.$message.warning('请至少选择一台设备')
                return
            }
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios.post(this.baseUrl3 + "instance/copyInstance", model)
            .then(({data: {code, data, msg}}) => {
                loading.close()
                if(code == 20000){
                    this.$message.success('复制成功')
                    this.cancel('copy')
                }else{
                    if(data.length > 0){
                        this.copyFailed = data
                    }
                    this.$message.error(msg)
                }
            })
            .catch(err=>{
                loading.close()
                console.log(err)
            })
        },
        cancel(val){
            this.$emit('closeCopyBox', val)
        },
        addNewDevice(){
            this.newDevices.push({
                ip:'',
                name: '',
                room: '',
                area: ''
            })
        },
        delNewDevice(index){
            this.newDevices.splice(index, 1)
        },
    }
}
</script>
<style scoped>

</style>
